@if (!loading) {
  <div class="documents-header">
    <div class="page-title">Files</div>
    @if (uploadedFiles.length > 0) {
      <div class="page-size">
        <app-page-size
          [pageSize]="pageSize"
          [selectId]="'document-table'"
          (pageSizeChanged)="onPageSizeChange($event)"
        ></app-page-size>
      </div>
    }
  </div>

  <div class="filter-search-section">
    <div class="filter-left-container" id="tour-files-filter">
      <app-filter-group
        [label]="'Filters'"
        [hasActiveFilters]="hasActiveFilters"
        [activeFilters]="activeFilters"
        (filterRemoved)="removeFilter($event)"
      >
        <!-- File Status & Operation Section -->
        @if (activeTab !== "pdm-files") {
          <div class="filter-section">
            <div class="filter-section-title">Upload Status & Operation</div>
            <div class="filter-row">
              <div class="filter-group">
                <label for="operationsFilter">File Operation</label>
                <select id="operationsFilter" [(ngModel)]="operationsFilter">
                  @for (opt of operationOptions; track opt.value) {
                    <option [value]="opt.value">{{ opt.option }}</option>
                  }
                </select>
              </div>
              @if (activeTab === "my-files") {
                <div class="filter-group">
                  <label for="uploadStatusFilter">Upload Status</label>
                  <select
                    id="uploadStatusFilter"
                    [(ngModel)]="uploadStatusFilter"
                  >
                    <option value="">All</option>
                    <option value="2">Success</option>
                    <option value="1">Pending</option>
                    <option value="3">Failed</option>
                    <option value="4">Malicious</option>
                  </select>
                </div>
              }
            </div>
          </div>
        }

        @if (activeTab !== "my-files" && isAdmin) {
          <div class="filter-section">
            <div class="filter-section-title">PDM FIles Sharing Status</div>
            <div class="filter-row">
              <div class="filter-group">
                <label for="pdmStatusFilter">Status</label>
                <select id="pdmStatusFilter" [(ngModel)]="pdmStatusFilter">
                  <option value="">All</option>
                  <option [value]="SharingStatus.NOT_UPLOADED">
                    Not Uploaded
                  </option>
                  <option [value]="SharingStatus.PENDING_APPROVAL">
                    Pending Approval
                  </option>
                  <option [value]="SharingStatus.APPROVED">Approved</option>
                  <option [value]="SharingStatus.REJECTED">Rejected</option>
                </select>
              </div>
            </div>
          </div>
        }

        @if (isAdmin && activeTab !== "pdm-files") {
          <div class="filter-divider"></div>

          <!-- User & Connection Section -->
          <div class="filter-section">
            <div class="filter-section-title">Uploaded By</div>
            <div class="filter-row">
              <div class="filter-group">
                <label for="uploadedConnectionFilter">CDFI</label>
                <select
                  id="uploadedConnectionFilter"
                  [(ngModel)]="uploadedConnectionFilter"
                  (ngModelChange)="onConnectionFilterChange()"
                  [disabled]="activeTab === 'my-files'"
                >
                  <option value="">All</option>
                  @for (connection of connections; track connection.id) {
                    <option [value]="connection.name">
                      {{ connection.display_name || connection.name }}
                    </option>
                  }
                </select>
              </div>
              <div class="filter-group">
                <label for="uploadedUserFilter">
                  User
                  @if (!uploadedConnectionFilter && activeTab !== "my-files") {
                    <span class="field-hint">(Select CDFI first)</span>
                  }
                </label>
                <select
                  id="uploadedUserFilter"
                  [(ngModel)]="uploadedUserFilter"
                  [disabled]="
                    !uploadedConnectionFilter || activeTab === 'my-files'
                  "
                >
                  <option value="">All</option>
                  @for (user of users; track user.id) {
                    <option [value]="user.username">
                      {{ user.first_name }} {{ user.last_name }}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>
        }

        <div class="filter-actions">
          <button class="btn-clear" (click)="clearFilters()">Clear</button>
          <button class="btn-apply" (click)="applyFilters()">Apply</button>
        </div>
      </app-filter-group>
    </div>

    <div class="search-section-wrapper" id="tour-files-search">
      <app-search-input
        [placeholder]="'Search ...'"
        [(searchQuery)]="searchQuery"
        (searchQueryChange)="onSearchQueryChange($event)"
      ></app-search-input>
    </div>
  </div>

  <div class="uploaded-files-wrapper">
    <div class="left-section">
      <div class="all-section">
        <div class="tab-switcher">
          <div
            id="tour-my-files-tab"
            class="tab-item"
            [class.active]="activeTab === 'my-files'"
            (click)="onTabChange('my-files')"
            (keyup.enter)="onTabChange('my-files')"
            tabindex="0"
          >
            My Files
          </div>
          <div
            id="tour-shared-files-tab"
            class="tab-item"
            [class.active]="activeTab === 'shared-files'"
            (click)="onTabChange('shared-files')"
            (keyup.enter)="onTabChange('shared-files')"
            tabindex="0"
          >
            {{ isAdmin ? "All Files" : "Shared Files" }}
          </div>
          @if (isAdmin) {
            <div
              class="tab-item"
              [class.active]="activeTab === 'pdm-files'"
              (click)="onTabChange('pdm-files')"
              (keyup.enter)="onTabChange('pdm-files')"
              tabindex="0"
            >
              PDM Files
            </div>
          }
        </div>
        <div class="right-section-buttons">
          <div class="upload-btn" id="tour-files-upload">
            <a href="javascript:void(0);" (click)="showUploadPopup = true">
              <app-svg-icon
                [iconName]="'upload.svg'"
                [height]="'18px'"
                [width]="'18px'"
                [style.fill]="'#fff'"
                [style.margin-right]="'5px'"
              ></app-svg-icon>
              <span>Upload New File</span>
            </a>
          </div>
        </div>
      </div>
      <div class="results-wrapper">
        @for (file of uploadedFiles; let i = $index; track $index) {
          <div
            class="each-result"
            [id]="'tour-file-item-' + i"
            (click)="onDownloadFile(file)"
            (keyup.enter)="onDownloadFile(file)"
            tabindex="0"
            style="cursor: pointer"
          >
            <div class="file-icon" [ngClass]="getFileIconClass(file.blob_name)">
              {{ getFileExtension(file.blob_name) }}
            </div>
            <div class="file-details">
              <div class="date">
                {{ file.uploaded_datetime | date: "medium" }}
              </div>
              <div class="name">{{ file.blob_name }}</div>
              <div class="user">
                @if (
                  loggedInUsername !== file.uploaded_user.username && !isAdmin
                ) {
                  Shared by:
                  <span class="user-connection-badge">
                    <span class="username"
                      >{{ file.uploaded_user.first_name }}
                      {{ file.uploaded_user.last_name }}</span
                    >
                    <span class="separator">•</span>
                    <span class="connection">{{
                      file.uploaded_user.connection.display_name ||
                        file.uploaded_user.connection.connection_name
                    }}</span>
                  </span>
                } @else {
                  Uploaded by:
                  <span class="user-connection-badge">
                    <span class="username"
                      >{{ file.uploaded_user.first_name }}
                      {{ file.uploaded_user.last_name }}</span
                    >
                    <span class="separator">•</span>
                    <span class="connection">{{
                      file.uploaded_user.connection.display_name ||
                        file.uploaded_user.connection.connection_name
                    }}</span>
                  </span>
                }
              </div>
            </div>

            <div class="file-status">
              @if (file.sharing_status && isAdmin) {
                <div
                  class="sharing-status-tag"
                  [ngClass]="{
                    pending:
                      file.sharing_status === SharingStatus.PENDING_APPROVAL,
                    approved: file.sharing_status === SharingStatus.APPROVED,
                    rejected: file.sharing_status === SharingStatus.REJECTED,
                  }"
                  (click)="onSharingStatusClick(file); $event.stopPropagation()"
                  (keyup.enter)="onSharingStatusClick(file)"
                  tabindex="0"
                  [class.clickable]="file.sharing_status > 1"
                >
                  @if (file.sharing_status === SharingStatus.PENDING_APPROVAL) {
                    <span class="status-dot animated"></span>
                  } @else if (file.sharing_status === SharingStatus.APPROVED) {
                    <svg
                      class="status-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  } @else if (file.sharing_status === SharingStatus.REJECTED) {
                    <svg
                      class="status-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  } @else {
                    <span class="status-dot"></span>
                  }
                  @switch (file.sharing_status) {
                    @case (SharingStatus.NOT_UPLOADED) {
                      Not Uploaded
                    }
                    @case (SharingStatus.PENDING_APPROVAL) {
                      Pending Approval
                    }
                    @case (SharingStatus.APPROVED) {
                      Approved
                    }
                    @case (SharingStatus.REJECTED) {
                      Rejected
                    }
                  }
                </div>
              }
              @if (
                loggedInUsername !== file.uploaded_user.username && !isAdmin
              ) {
                <div class="shared-tag">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 640 640"
                    width="12"
                    height="12"
                    fill="white"
                    style="margin-right: 4px"
                  >
                    <path
                      d="M371.8 82.4C359.8 87.4 352 99 352 112L352 192L240 192C142.8 192 64 270.8 64 368C64 481.3 145.5 531.9 164.2 542.1C166.7 543.5 169.5 544 172.3 544C183.2 544 192 535.1 192 524.3C192 516.8 187.7 509.9 182.2 504.8C172.8 496 160 478.4 160 448.1C160 395.1 203 352.1 256 352.1L352 352.1L352 432.1C352 445 359.8 456.7 371.8 461.7C383.8 466.7 397.5 463.9 406.7 454.8L566.7 294.8C579.2 282.3 579.2 262 566.7 249.5L406.7 89.5C397.5 80.3 383.8 77.6 371.8 82.6z"
                    />
                  </svg>
                  Shared
                </div>
              }
            </div>

            <div class="right-actions">
              @if (file.upload_status === 1) {
                <div class="pending-tag">
                  <span class="status-dot"></span>
                  Processing
                </div>
              }
              @if (file.upload_status === 4) {
                <div class="malicious-tag">Malicious</div>
              }
              @if (
                (loggedInUsername === file.uploaded_user.username || isAdmin) &&
                file.upload_status !== 1 &&
                file.upload_status !== 4
              ) {
                <a
                  [id]="'tour-file-item-info-' + i"
                  href="javascript:void(0);"
                  (click)="onShowOperations(file); $event.stopPropagation()"
                  title="View Operations"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512">
                    <path
                      d="M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-192-32 0c-17.7 0-32-14.3-32-32z"
                    />
                  </svg>
                </a>
              }
              @if (
                (loggedInUsername === file.uploaded_user.username || isAdmin) &&
                file.upload_status !== 1 &&
                file.upload_status !== 4
              ) {
                <a
                  [id]="'tour-file-item-share-' + i"
                  href="javascript:void(0);"
                  (click)="onShareFile(file); $event.stopPropagation()"
                  title="Share"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                    <path
                      d="M371.8 82.4C359.8 87.4 352 99 352 112L352 192L240 192C142.8 192 64 270.8 64 368C64 481.3 145.5 531.9 164.2 542.1C166.7 543.5 169.5 544 172.3 544C183.2 544 192 535.1 192 524.3C192 516.8 187.7 509.9 182.2 504.8C172.8 496 160 478.4 160 448.1C160 395.1 203 352.1 256 352.1L352 352.1L352 432.1C352 445 359.8 456.7 371.8 461.7C383.8 466.7 397.5 463.9 406.7 454.8L566.7 294.8C579.2 282.3 579.2 262 566.7 249.5L406.7 89.5C397.5 80.3 383.8 77.6 371.8 82.6z"
                    />
                  </svg>
                </a>
              }
              @if (file.upload_status !== 1 && file.upload_status !== 4) {
                <a
                  [id]="'tour-file-item-download-' + i"
                  href="javascript:void(0);"
                  (click)="onDownloadFile(file, true); $event.stopPropagation()"
                  title="Download"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    width="16"
                    height="16"
                    fill="currentColor"
                  >
                    <path
                      d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                    />
                  </svg>
                </a>

                <a
                  [id]="'tour-file-item-report-' + i"
                  href="javascript:void(0);"
                  class="file-report-icon"
                  title="Flag File"
                  (click)="onReportFile(file); $event.stopPropagation()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
                    ></path>
                    <line x1="4" y1="22" x2="4" y2="15"></line>
                  </svg>
                </a>
              }

              @if (
                loggedInUsername === file.uploaded_user.username &&
                (file.upload_status !== 1 ||
                  (file.upload_status === 1 &&
                    isOlderThan24Hours(file.uploaded_datetime))) &&
                file.upload_status !== 4
              ) {
                <a
                  [id]="'tour-file-item-delete-' + i"
                  href="javascript:void(0);"
                  class="file-delete-icon"
                  title="Delete"
                  (click)="onDeleteFile(file); $event.stopPropagation()"
                >
                  <app-svg-icon
                    [iconName]="'delete.svg'"
                    [height]="'16px'"
                    [width]="'14px'"
                    [style.fill]="'#334ea5'"
                  ></app-svg-icon>
                </a>
              }
            </div>
          </div>
        } @empty {
          <div class="no-data-wrapper">
            <div class="no-data">
              <app-svg-icon
                [iconName]="'no-data.svg'"
                [height]="'100px'"
                [width]="'100px'"
              ></app-svg-icon>
              <div class="text-holder">No files found</div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  @if (uploadedFiles.length > 0) {
    <app-pagination
      [currentPage]="currentPage"
      [pageSize]="pageSize"
      [totalItems]="totalFiles"
      (pageChanged)="onPageChange($event)"
    ></app-pagination>
  }
} @else {
  <div class="documents-header">
    <div class="page-title">Files</div>
  </div>
  <div class="uploaded-files-wrapper">
    <div class="left-section">
      <div class="all-section">
        <div class="right-section-buttons"></div>
      </div>
      <div class="results-wrapper">
        <div class="each-result">
          <div class="file-details">
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
          </div>
        </div>
        <div class="each-result">
          <div class="file-details">
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
          </div>
        </div>
        <div class="each-result">
          <div class="file-details">
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
            <div class="skeleton-box"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (showUploadPopup) {
  <app-secondary-popup
    [title]="'Upload New File'"
    [isActionButtonsAvailable]="false"
    (popupClosed)="onUploadPopupClose($event)"
  >
    <app-document-upload
      [fileOperations]="fileOperations"
      (fileUploaded)="onFileUploaded()"
    ></app-document-upload>
  </app-secondary-popup>
}

@if (showConfirmPopup) {
  <app-popup
    [heading]="'Confirm Delete'"
    [confirmText]="'Delete'"
    [cancelText]="'Cancel'"
    (confirmClicked)="onConfirmDelete()"
    (cancelClicked)="showConfirmPopup = false"
  >
    Are you sure you want to delete the file: {{ popupFile.blob_name }}?
  </app-popup>
}

@if (showApprovePopup) {
  <app-popup
    [heading]="approvePopupHeading"
    [confirmText]="'Approve'"
    [cancelText]="'Reject'"
    [showCloseIcon]="true"
    [showFooterButtons]="isSharingApprovalActionable"
    (confirmClicked)="onConfirmApprove()"
    (cancelClicked)="onRejectApproval($event)"
  >
    <div class="sharing-popup-content">
      @if (isSharingApprovalActionable) {
        <div class="file-info-box">
          <span class="file-label">File:</span>
          <span class="file-name">{{ approveFile.blob_name }}</span>
        </div>
      }

      <div class="sharing-info-section">
        @if (isSharingApprovalActionable) {
          <div class="sharing-intro-text">
            Requested to share this file with:
          </div>
        }

        @if (loadingSharingInfo) {
          <div class="info-loading">Loading sharing info...</div>
        } @else {
          <div class="info-group">
            <div class="info-label">Users:</div>
            @if (approveSharingInfo?.users?.length) {
              <div class="info-list">
                @for (user of approveSharingInfo!.users; track user.id) {
                  <span class="info-chip">{{ user.name }}</span>
                }
              </div>
            } @else {
              <div class="info-empty">None</div>
            }
          </div>

          <div class="info-group">
            <div class="info-label">Connections:</div>
            @if (approveSharingInfo?.connections?.length) {
              <div class="info-list">
                @for (conn of approveSharingInfo!.connections; track conn.id) {
                  <span class="info-chip">{{ conn.name }}</span>
                }
              </div>
            } @else {
              <div class="info-empty">None</div>
            }
          </div>
        }
      </div>
    </div>
  </app-popup>
}

@if (showSharePopup) {
  <app-document-share
    [showSharePopup]="showSharePopup"
    [shareFile]="shareFile"
    (sharePopupClosed)="onSharePopupClosed()"
    (shareCompleted)="onShareCompleted($event)"
    (filesNeedRefresh)="onFilesNeedRefresh()"
  ></app-document-share>
}

@if (showOperationsPopup) {
  <app-document-operations-modal
    [file]="operationsFile"
    [fileOperations]="getModalFileOperations(operationsFile)"
    (closeModal)="onOperationsPopupClose()"
    (operationCompleted)="onRetriggerOperationCompleted()"
  ></app-document-operations-modal>
}

<app-file-viewer
  [fileUrl]="viewerFileUrl"
  [fileName]="viewerFileName"
  [showViewer]="showFileViewer"
  (closeViewer)="onCloseViewer()"
  (downloadFile)="onViewerDownload()"
></app-file-viewer>
